module.exports = __webpack_public_path__ + "img/coating-xtraclean.3333e6ad.svg";